export default __webpack_public_path__ + "static/media/pic2.ba5db75e.png";